<ng-container infiniteScroll [infiniteScrollDistance]="0.5" [infiniteScrollContainer]="'.main-view'"
    [infiniteScrollThrottle]="50" [fromRoot]="true" (scrolled)="onMcqScroll()">

    <!-- Empty State Message -->
    <div class="empty-state-container" *ngIf="!mcqsInfo?.questions || mcqsInfo?.questions?.length === 0">
        <div class="empty-state-content">
            <div class="empty-state-icon">
                <mat-icon>quiz</mat-icon>
            </div>
            <h3 class="empty-state-title">No Multiple Choice Questions Available</h3>
            <p class="empty-state-description">
                No multiple choice questions found for the selected criteria.
                Try adjusting your filters or generate new questions.
            </p>
        </div>
    </div>

    <div class="mcq-card" *ngFor="let item of mcqsInfo?.questions; let qi = index"
        [class.flash-highlight]="item._highlight">
        <div class="undo-section" *ngIf="item.selected && !(item.displayText?.length || item.error)">
            <app-undo class="undo-comp" [undoItem]="undoSelectedItem"
                (undoAction)="undoSelectedIQuestion(item)"></app-undo>
        </div>

        <div class="mcq-header">
            <div class="mcq-header-left">
                <mat-checkbox class="mcq-select-checkbox" [checked]="item._selected"
                    (change)="onSelectChange(item, $event)" (click)="$event.stopPropagation()"
                    [disabled]="item.selected" *ngIf="showCheckboxes" color="primary"></mat-checkbox>
                <div class="question-identity">
                    <span class="q-label">Q{{qi+1}}</span>
                </div>
                <span class="difficulty-chip" [ngClass]="item.difficultyLevel?.toLowerCase() || 'medium'">
                    <mat-icon class="difficulty-icon">signal_cellular_alt</mat-icon>
                    {{ item.difficultyLevel | difficultyLevel }}
                </span>

                <button mat-icon-button [matMenuTriggerFor]="mcqMenu" class="more-actions-btn"
                    *ngIf="!item.regenerate && !item.selected && !mcqsInfo?.isPreview && (mcqsInfo?.from === 'questionsList' || mcqsInfo?.category === 'GENERATED' || mcqsInfo?.category === 'PREVIOUSLYGENERATED' || mcqsInfo?.category === 'SELECTED')"
                    (click)="setMenuItem(item); $event.stopPropagation()">
                    <mat-icon>more_horiz</mat-icon>
                </button>
            </div>

            <div class="mcq-header-right">
                <button mat-button class="select-btn"
                    *ngIf="mcqsInfo?.category === 'GENERATED' || mcqsInfo?.category === 'PREVIOUSLYGENERATED'"
                    (click)="$event.stopPropagation();addMcqToAssessment(item);"
                    [disabled]="item.regenerate || item.selected" [ngClass]="{'is-selected': item.selected}">
                    <mat-icon>{{ item.selected ? 'check' : 'add' }}</mat-icon>
                    {{ item.selected ? 'Selected' : 'Select' }}
                </button>

                <button mat-button class="remove-btn" *ngIf="mcqsInfo?.category === 'SELECTED'"
                    (click)="$event.stopPropagation(); removeSelectedMCQ.emit(item);">
                    <mat-icon>remove_circle_outline</mat-icon>
                    Remove
                </button>

                <button mat-icon-button class="expand-btn" (click)="toggleExpand(item)"
                    [disabled]="item.regenerate || item.selected">
                    <mat-icon class="expand-icon" [class.is-expanded]="item.expanded">expand_more</mat-icon>
                </button>
            </div>
        </div>

        <div class="mcq-body"
            [ngClass]="{'dimmed': item.selected && !(item.displayText?.length || item.error), 'regenerate-center': item.regenerate}">
            <ng-container *ngIf="item.regenerate; else normalContent">
                <app-generate-loader [displayText]="displayText" [genearateSuccess]="genearateSuccess"
                    [reGenerate]="true"></app-generate-loader>
            </ng-container>

            <ng-template #normalContent>
                <div class="insight-board">
                    <!-- Section Label Row for Question Details -->
                    <div class="section-label-row no-border" *ngIf="!item.edit_clicked">
                        <div class="section-label">
                            <mat-icon class="section-icon">description</mat-icon>
                            <span>Question Details</span>
                        </div>
                        <div class="section-actions">
                            <button mat-icon-button class="edit-btn"
                                *ngIf="mcqsInfo.from !== 'preview' && !mcqsInfo.isPreview" (click)="onEditClick(item)">
                                <mat-icon>edit</mat-icon>
                            </button>
                        </div>
                    </div>

                    <!-- Question Content Section in Edit Mode -->
                    <div class="section-label-row no-border" *ngIf="item.edit_clicked">
                        <div class="section-label">
                            <mat-icon class="section-icon">description</mat-icon>
                            <span>Question Content</span>
                        </div>
                    </div>

                    <div class="question-text-container">
                        <ng-container *ngIf="!item?.edit_clicked; else questionEditor">
                            <div class="question-text" [innerHTML]="formatQuestionText(item.questionText)"></div>
                        </ng-container>
                        <ng-template #questionEditor>
                            <div class="edit-question-block inplace">
                                <angular-editor class="edit-question-textarea" (click)="$event.stopPropagation()"
                                    (keydown)="$event.stopPropagation()" (keyup)="$event.stopPropagation()"
                                    [(ngModel)]="item.temp_questionText" [config]="editorEditConfig" id="q-text-{{qi}}">
                                </angular-editor>
                            </div>
                        </ng-template>
                    </div>

                    <div class="tags-container" *ngIf="!item.edit_clicked">
                        <div class="subtopics-list" *ngIf="item.subTopics?.length">
                            <span class="tag-badge subtopic" *ngFor="let topic of item.subTopics">
                                <mat-icon>folder</mat-icon>
                                {{ topic.name }}
                            </span>
                        </div>
                        <div class="topics-list" *ngIf="!item.subTopics?.length && item.topics?.length">
                            <span class="tag-badge topic" *ngFor="let topic of item.topics">
                                <mat-icon>tag</mat-icon>
                                {{ topic.topic }}
                            </span>
                        </div>
                    </div>
                </div>

                <!-- Options Section (visible if expanded OR edit_clicked) -->
                <div class="options-section-container" *ngIf="item.expanded || item.edit_clicked">

                    <!-- Read-only Options List -->
                    <div class="options-list" *ngIf="!item.edit_clicked">
                        <div *ngFor="let optionItem of item.options; let i = index" class="option-row"
                            [ngClass]="{'correct-answer': i === getAnswerIndex(item)}">
                            <div class="option-marker">
                                <span class="option-letter">{{('A').charAt(0) | strings:i}}</span>
                            </div>
                            <div class="option-content" [innerHTML]="formatQuestionText(optionItem)"></div>
                            <mat-icon class="correct-icon" *ngIf="i === getAnswerIndex(item)">check_circle</mat-icon>
                        </div>
                    </div>

                    <!-- Edit Mode Options List -->
                    <div class="edit-options-list" *ngIf="item.edit_clicked">
                        <div *ngFor="let option of item.options; let oi = index" class="edit-option-row premium"
                            [class.is-correct]="oi === item.temp_answerIndex">
                            <div class="option-selection">
                                <mat-radio-button name="edit-answer-{{item._id}}"
                                    [checked]="oi === item.temp_answerIndex" (change)="item.temp_answerIndex = oi"
                                    [matTooltip]="'Mark as correct answer'"></mat-radio-button>
                            </div>

                            <div class="option-marker">
                                <span class="option-letter">{{('A').charAt(0) | strings:oi}}</span>
                            </div>

                            <div class="option-input-wrapper">
                                <ng-container *ngIf="item.editingOptionIndex !== oi">
                                    <div class="option-preview-text" (click)="onEditOption(item, oi)">
                                        <span [innerHTML]="formatQuestionText(option)"></span>
                                        <mat-icon class="edit-hint-icon">edit</mat-icon>
                                    </div>
                                </ng-container>
                                <ng-container *ngIf="item.editingOptionIndex === oi">
                                    <div class="edit-option-field">
                                        <angular-editor [(ngModel)]="item.temp_optionValue" [config]="editorEditConfig"
                                            class="edit-option-input" id="opt-edit-{{qi}}-{{oi}}"></angular-editor>
                                        <div class="option-actions-inline">
                                            <button mat-button class="cancel-btn"
                                                (click)="onCancelOption(item)">Cancel</button>
                                            <button mat-flat-button class="save-btn" color="primary"
                                                (click)="onSaveOption(item, oi)">Apply</button>
                                        </div>
                                    </div>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Integrated Bottom Right Actions -->
                <div class="edit-footer-actions" *ngIf="item.edit_clicked">
                    <button mat-button class="cancel-btn" (click)="onEditCancelBtnClick(item)">Cancel</button>
                    <button mat-flat-button class="save-btn" color="primary" (click)="onEditDone(item)">Save</button>
                </div>

            </ng-template>
        </div>
    </div>

    <mat-menu #mcqMenu="matMenu">
        <button mat-menu-item
            *ngIf="mcqsInfo?.from === 'questionsList' || mcqsInfo?.category === 'GENERATED' || mcqsInfo?.category === 'PREVIOUSLYGENERATED' || mcqsInfo?.category === 'SELECTED'"
            (click)="$event.stopPropagation(); onEditClick(menuItem)">
            <mat-icon>edit</mat-icon> Edit
        </button>
        <button mat-menu-item
            *ngIf="mcqsInfo?.from === 'questionsList' || mcqsInfo?.category === 'GENERATED' || mcqsInfo?.category === 'PREVIOUSLYGENERATED'"
            (click)="$event.stopPropagation(); onDuplicate(menuItem)">
            <mat-icon>content_copy</mat-icon> Duplicate
        </button>
        <button mat-menu-item
            *ngIf="mcqsInfo?.from === 'questionsList' || mcqsInfo?.category === 'GENERATED' || mcqsInfo?.category === 'PREVIOUSLYGENERATED'"
            (click)="$event.stopPropagation(); confirmDeleteSelected(menuItem)">
            <mat-icon>delete</mat-icon> Delete
        </button>
        <button mat-menu-item *ngIf="mcqsInfo?.category === 'GENERATED'"
            (click)="$event.stopPropagation(); openRegenerateDialog(menuItem)">
            <mat-icon>autorenew</mat-icon> Regenerate
        </button>
    </mat-menu>
</ng-container>